import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { Pattern } from "@dffedb/util";

export class FlyttemeddelelseUdbetalingFormBuilder {
    public static opretForm(): UntypedFormGroup {
        return new UntypedFormBuilder().group({
            registreringsnr: [null, Validators.pattern(Pattern.registreringsNr)],
            kontonr: [null, Validators.pattern(Pattern.kontoNr)]
        });
    }
}
